/* import __COLOCATED_TEMPLATE__ from './invite-to-company-admin-modal.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { closeModal } from 'sh-www/utils/modal-controls';

/** @module */
export default Component.extend({
  tagName: '',

  companyCommandService : service('commands/company-commands'),

  /** @inheritDoc */
  actions: {
    /**
     * @return {Promise<Company>}
     */
    loadTeamMembers() {
      return this.get('companyCommandService').loadCompany(this.get('model.company.id'), ['approved-employees', 'invites']);
    },

    /**
     * @param {Object} jsonData
     * @param {string} jsonData.first_name
     * @param {string} jsonData.last_name
     * @param {string} jsonData.email
     * @param {boolean} jsonData.is_admin
     * @return {Promise<void>}
     */
    sendInvite(jsonData) {
      return this.companyCommandService.inviteUserToCompany(this.model.company, jsonData, [], false).then((invite) => {
        this.model.onInviteSucceeded?.(invite);
        closeModal(this);
      });
    },

    /**
     *
     */
    onCancel() {
      closeModal(this);
    },
  },
});
